<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex items-start gap-3 min-w-0 flex-1">
            <ReflectionIcon :kind="kind" size="md" class="mt-1 shrink-0" />
            <div class="flex flex-col gap-1 min-w-0">
                <div class="body-semibold text-ink">{{ title }}</div>
                <p class="scaffold-body-small text-ink-muted"><slot /></p>
            </div>
        </div>
        <a
            v-if="href"
            :href="href"
            class="base-btn-neutral base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            :aria-label="`${LAUNCH_TEXT} ${title}`"
            @click.prevent="emit('launch')">
            {{ LAUNCH_TEXT }}
        </a>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon, { type ReflectionIconKind } from "~vue/pages/reflections/ReflectionIcon.vue";

const LAUNCH_TEXT = "Launch";

interface Props {
    kind: ReflectionIconKind;
    title: string;
    // Rows without a destination (team review) render as copy only, since
    // giving feedback depends on a teammate asking first.
    href?: string;
}

defineProps<Props>();
const emit = defineEmits<{ (event: "launch"): void }>();
</script>
